export default (betKey) => {
  const splitKey = betKey.split(':')
  switch (true) {
    case splitKey.length === 3 && splitKey[1] === 'LOCATE':
    case splitKey.length === 5:
      return splitKey[0]

    case splitKey.length === 2:
      return splitKey[1]

    default:
      return splitKey[2]
  }
}
